
import en from './en';

import dateTimeFormats from './date-time-formats';
import numberFormats from './number-formats';

export default {

	dateTimeFormats: dateTimeFormats,
	numberFormats: numberFormats,

	messages: {
		en
	}

};



// WEBPACK FOOTER //
// ./src/locales/index.js